import { CA } from 'src/app/shared/entities/ca';
import { createPageDataFeature } from '../../page-data/create-page-data-feature';

export const {
  feature: calistDataFeature,
  selectors: CalistDataSelectors,
  actions: CalistDataActions,
  pipes: CalistDataPipes,
  createEffects: createCalistDataEffects,
} = createPageDataFeature<'CA Data', void, CA[]>('CA Data');
